module.exports = __webpack_public_path__ + "assets/img/1201_02.jpg?92a3e5420f03b27a3ac8eb43b8d74cda";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1201_02.jpg
// module id = 1070
// module chunks = 0